import React, { useState } from "react";
import Section from "./Section";
import MembershipForm from "./MembershipForm";
import MembershipVerify from "./MembershipVerify";
import content from "../content.json";
import { toast } from "react-toastify";

const Sections = () => {
  const [view, setView] = useState("main");

  const showForm = () => setView("form");
  const showVerify = () => setView("verify");
  const showMain = () => {
    toast.dismiss();
    setView("main");
  };

  if (view === "form") return <MembershipForm onBack={showMain} />;
  if (view === "verify") return <MembershipVerify onBack={showMain} />;

  return (
    <>
      <Section {...content.about} />
      <Section
        {...content.services}
        button
        onApplyClick={showForm}
        onVerifyClick={showVerify}
      />
      <Section {...content.contact} />
    </>
  );
};

export default Sections;
